import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { AdminHomePage, type AdminHomeSearch } from '@/features/admin';

/**
 * "Tashkilotlar" — organizations for the platform admin. An organization admin of a single organization goes straight
 * to it. The shell guard (`canAccessPath`) shows "Ruxsat yo'q" to everyone else.
 */
export const Route = createFileRoute('/_authed/_app/admin/')({
  validateSearch: z.object({
    q: z.string().optional().catch(undefined),
    panel: z.string().optional().catch(undefined),
  }),
  beforeLoad: ({ context }) => {
    const { me } = context;
    if (me.isPlatformAdmin) return;
    const orgs = me.organizations.filter((o) => o.isAdmin);
    if (orgs.length === 1) throw redirect({ to: '/admin/organizations/$orgId', params: { orgId: orgs[0]!.slug }, replace: true });
  },
  component: AdminRoute,
});

function AdminRoute() {
  const { me } = Route.useRouteContext();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <AdminHomePage
      me={me}
      search={search}
      onSearchChange={(patch: Partial<AdminHomeSearch>) => void navigate({ search: (prev: AdminHomeSearch) => ({ ...prev, ...patch }), replace: true })}
      onOpen={(org) => void navigate({ to: '/admin/organizations/$orgId', params: { orgId: org.slug } })}
    />
  );
}
